import { useQuery } from "react-query";
import axios from "axios";

// import firebase from 'firebase/compat/app';
// import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDUdAQQbHLNlWqvQbWzQHB53flblWdbQcY",
  authDomain: "numazu-station-signage.firebaseapp.com",
  databaseURL: "https://numazu-station-signage-default-rtdb.firebaseio.com",
  projectId: "numazu-station-signage",
  storageBucket: "numazu-station-signage.appspot.com",
  messagingSenderId: "379713052866",
  appId: "1:379713052866:web:d43846df049a394bd71b5b",
  measurementId: "G-ZK6PNN3JZH"
};

// firebase.initializeApp(firebaseConfig);
// const storage = firebase.storage();


const getTimeTables = async (props) => {
  const platform_code = props.queryKey[0];
  // const jsonName = `${platform_code}_timetable.json`
  // const pathReference = storage.ref('images/stars.jpg');
  const url = `https://firebasestorage.googleapis.com/v0/b/numazu-station-signage.appspot.com/o/json%2F${platform_code}_timetable.json?alt=media`;
  // const url = `https://storage.cloud.google.com/numazu-station-signage.appspot.com/json/${platform_code}_timetable.json`
  console.log(url)
  const { data } = await axios.get(url);

  console.log("getTimeTables " + props.queryKey[0]);
  console.log(data);
  return data;
};

export const useQueryTimeTables = (platformCode) => {
  return useQuery({
    queryKey: [platformCode, "timetables"],
    queryFn: getTimeTables,
    cacheTime: 36000000,
    staleTime: 36000000
  });
};
// 60000 => 1分
// 3600000 => 1時間
// 36000000 => 10時間
// 72000000 => 20時間
